import React, { useState } from "react";

import { Dispatch, State } from "../types";
import { Block as BlockComponent } from "./Block";

import "./styles.scss";

type Props = Readonly<{
  dispatch: Dispatch;
  state: State;
}>;

const Block = React.memo(BlockComponent);

export const TextView = ({
  dispatch,
  state: { activeBlockOrder, blocks, selectedBlockId, scrollToTextBlock, selectedCellId, readonly },
}: Props) => {
  const [scrollRef, setScrollRef] = useState<HTMLElement | null>(null);
  return (
    <div className="text-view" ref={setScrollRef}>
      {scrollRef &&
        activeBlockOrder.map(b => {
          return (
            <Block
              selectedCellId={selectedCellId}
              readonly={readonly}
              active={selectedBlockId === b}
              block={blocks[b]}
              dispatch={dispatch}
              key={b}
              scrollRef={scrollRef}
              scrollTo={b === scrollToTextBlock}
            />
          );
        })}
    </div>
  );
};
